<template>
	<div>
	<!-- 标题组件 -->
		<el-card>
			<el-row class="yl-title-sub">
				<el-col :span="12">{{title}}</el-col>
                <el-col :span="12" class="text-right"><el-button size="small" type="primary" v-if="isEdit" @click="handleClick">编辑</el-button></el-col>			</el-row>
            <el-row :class="rowClass" v-if="!editFlag">
				<el-col :span="colSpan" v-for="(item,index) in queryParams" :key="index">
                    <span>{{item.label}}: </span>
                    <span :class="item.attr.type === 'link' ? 'text-link': 'text'" @click="handleLink(item)">
                        {{matchField(item.content,item) || '--'}}
                    </span>
                </el-col>
			</el-row>
			<el-row :class="rowClass" v-if="editFlag">
				<el-col :span="colSpan" v-for="(item,index) in queryParams" :key="index">
                    <span>{{item.label}}: </span>
                    <el-input v-model="item.inputValue" />
                </el-col>
			</el-row>
            <el-row v-if="isEdit" type="flex" justify="center">
				<el-button type="primary" @click="handleOk">确定</el-button>
                <el-button @click="handleCancel">取消</el-button>
            </el-row>
		</el-card>
	</div>
</template>
<script>
export default {
    name:"yl-lc-formReadOnly",
    props: {
        formTitle: {
            type:String,
            default: 'yl-singleForm'
        },
        formSpan: {
            type: String,
            default: 'one'
        },
        formSpanContent: {
            type:String,
            default: ''
        },
        params: {
            type: Array,
            default: []
        },
        title: {
            type:String,
            default: '单列表单'
        },
        isEdit: {
            type:Boolean,
            default: false
        }
    },
    watch: {
        formTitle: {
            handler(data) {
                this.colSpan = this.spanList[data];
            },
            immediate: true
        },
        params: {
            handler(data) {
                this.queryParams = data;
            },
            immediate: true
        }
    },
    computed:{
        rowClass(){
            return this.formTitle === 'yl-singleForm' ? 'yl-singleForm form_read' : 'form_read'
        }
    },
    data() {
        return {
            formTypeList: { 'yl-singleForm': '单列表单', 'yl-doubleForm': '双列表单', 'yl-threeForm' : '三列表单'},
            spanList: { 'yl-singleForm': 24, 'yl-doubleForm': 12, 'yl-threeForm' : 8},
            colSpan: 24,
            editFlag: false,
            queryParams: [],
            style: this.style
        }
    },
    mounted() {
        this.queryParams = this.params
    },
    methods: {
        matchField(item,data){
            let res = "";
            let list = [];
            if(data.attr.type == 'enum'){
                if(typeof data.attr.list == "string"){
                    list = eval(list);
                }else{
                    list = data.attr.list;
                }
                list.map(child=>{
                    if(child[data.attr.key] == item){
                        res = child[data.attr.content];
                    }
                })
            }
            if(data.attr.type == 'text' || data.attr.type == 'link' ){
                res = item
            }
            if(data.attr.type == 'date'){
                res = this.$function.DATE.strToTime(item, data.formatDate) || '--'
            }
            if(data.attr.type == 'amount'){
                if(data.formatAmount === 'normalAmount'){
                    res = item
                }
                if(data.formatAmount === 'formatAmount'){
                    res = this.$function.AMOUNT.format(item, data.reserveDecimals, "", false, true)
                }
            }
            return res;    
        },
        handleLink(item){
            if(item.attr.type == 'link'){
                if(item.__on__){
                    let e = item.__on__.find(item=>item.eventName=='Click');
                    //执行组件绑定方法
                    if(e){
                        this.$store.getters.exeMethods(e);
                    }
                }
            }
            return false;
        },
        handleClick(){
            this.editFlag = true;
            this.queryParams.forEach(item => {
                this.$set(item, "inputValue", item.content)
            });
        },
        handleOk(){
            this.editFlag = false;
        },
        handleCancel(){
            this.editFlag = false;
        },
    },
}
</script>
<style lang='less' scoped>
.text-link {
    color: #179CFF;
}
</style>